export default {
  accessorial (state, getters, rootState) {
    return state.accessorial
  },
  'brand-group' (state, getters, rootState) {
    return state['brand-group']
  },
  country (state, getters, rootState) {
    return state.country
  },
  calculation (state, getters, rootState) {
    return state.calculation
  },
  'consolidation-point': function (state, getters, rootState) {
    return state['consolidation-point']
  },
  currency (state, getters, rootState) {
    return state.currency
  },
  'data-option': function (state, getters, rootState) {
    return state['data-option']
  },
  document: function (state, getters, rootState) {
    return state.document
  },
  'exchange-rate': function (state, getters, rootState) {
    return state['exchange-rate']
  },
  'exchange-rate-history': function (state, getters, rootState) {
    return state['exchange-rate-history']
  },
  'financial-code': function (state, getters, rootState) {
    return state['financial-code']
  },
  'financial-profile': function (state, getters, rootState) {
    return state['financial-profile']
  },
  'job-type': function (state, getters, rootState) {
    return state['job-type']
  },
  location: function (state, getters, rootState) {
    return state.location
  },
  lookup: function (state, getters, rootState) {
    return state.lookup
  },
  'port-area': function (state, getters, rootState) {
    return state['port-area']
  },
  party: function (state, getters, rootState) {
    return state.party
  },
  'party-group': function (state, getters, rootState) {
    return state['party-group']
  },
  'point-to-port': function (state, getters, rootState) {
    return state['point-to-port']
  },
  'quote-tax': function (state, getters, rootState) {
    return state['quote-tax']
  },
  role: function (state, getters, rootState) {
    return state.role
  },
  'routing-rules': function (state, getters, rootState) {
    return state['routing-rules']
  },
  'spreadsheet-descriptor': function (state, getters, rootState) {
    return state['spreadsheet-descriptor']
  },
  'spreadsheet-descriptor-parent': function (state, getters, rootState) {
    return state['spreadsheet-descriptor-parent']
  },
  'transit-miles': function (state, getters, rootState) {
    return state['transit-miles']
  },
  'user-group': function (state, getters, rootState) {
    return state['user-group']
  },
  'mai-user': function (state, getters, rootState) {
    return state['mai-user']
  },
  'vendor-zone': function (state, getters, rootState) {
    return state['vendor-zone']
  },
  'request-for-proposal': function (state, getters, rootState) {
    return state['request-for-proposal']
  },
  lookupsFromDetailsSearch: function (state, getters, rootState) {
    return state.lookupsFromDetailsSearch
  },
  lookupDetailsToggle: function (state, getters, rootState) {
    return state.lookupDetailsToggle
  },
  vendorZoneLocations: function (state, getters, rootState) {
    return state.vendorZoneLocations
  },
  vendorZoneLocationsCount: function (state, getters, rootState) {
    return state.vendorZoneLocationsCount
  },
  portAreaToPorts: function (state, getters, rootState) {
    return state.portAreaToPorts
  },
  pointToPortToPorts: function (state, getters, rootState) {
    return state.pointToPortToPorts
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/store/getters.js